import type { EntityType, TrackMeta, TrackPage } from "domains/analytics/types";
import type { Topic } from "entities/topics/types";

export const getTopicPageEvent = (topic: Topic, keyIssue?: Topic, subpage?: TrackPage) => {
  const event = getTopicRelatedItemDetailPageEvent("Topic detail", topic, "Topic", keyIssue);
  return { ...event, subpage };
};

type RelatedItem = { id: string; name: string };

export const getTopicRelatedItemDetailPageEvent = (
  page: TrackPage,
  relatedItem: RelatedItem,
  relatedItemType: EntityType,
  topic?: Topic,
) => {
  let params: TrackMeta = {
    name: "Browse page",
    page,
    subpage: page === "Topic detail" ? undefined : "Topic detail",
    entityId: relatedItem.id,
    entityType: relatedItemType,
    entityName: relatedItem.name,
  };
  if (topic) {
    params = {
      ...params,
      secondaryEntityId: topic.id,
      secondaryEntityName: topic.name,
      secondaryEntityType: "Topic",
    };
  }
  return params;
};
